import { render, staticRenderFns } from "./OpeningBalance.vue?vue&type=template&id=293ff864&scoped=true"
import script from "./OpeningBalance.vue?vue&type=script&lang=js"
export * from "./OpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalance.vue?vue&type=style&index=0&id=293ff864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293ff864",
  null
  
)

export default component.exports